export const CATEGORIES = [
  { value: "fruits_legumes", label: "Fruits et légumes", icon: "🥬" },
  { value: "viandes", label: "Viandes", icon: "🥩" },
  { value: "poisson", label: "Poisson", icon: "🐟" },
  { value: "produits_frais", label: "Produits frais", icon: "🧀" },
  { value: "epicerie", label: "Épicerie", icon: "🛒" },
  { value: "sauces_condiments", label: "Sauces et condiments", icon: "🫙" },
  { value: "boulangerie", label: "Boulangerie", icon: "🥖" },
  { value: "surgele", label: "Surgelés", icon: "❄️" },
  { value: "autre", label: "Autre", icon: "📦" },
];

export const categoryLabel = (v) =>
  (CATEGORIES.find((c) => c.value === v) || CATEGORIES[CATEGORIES.length - 1]).label;
export const categoryIcon = (v) =>
  (CATEGORIES.find((c) => c.value === v) || CATEGORIES[CATEGORIES.length - 1]).icon;

export const UNITS = [
  "g", "kg", "ml", "cl", "L", "pièce", "paquet", "sachet",
  "pot", "gousse", "cm", "cs", "cc", "selon votre goût", "",
];

export const SECTIONS = [
  { value: "ingredients", label: "Ingrédients" },
  { value: "a_ajouter_vous_meme", label: "À ajouter vous-même" },
];

export const DEFAULT_PANTRY = [
  "Sel", "Poivre", "Huile d'olive", "Beurre", "Farine", "Sucre", "Vinaigre",
];

export const CUISINES = [
  { value: "francaise", label: "Français" },
  { value: "italienne", label: "Italien" },
  { value: "mediterraneenne", label: "Méditerranéen" },
  { value: "asiatique", label: "Asiatique" },
  { value: "indienne", label: "Indien" },
  { value: "mexicaine", label: "Mexicain" },
  { value: "moyen_orient", label: "Moyen-Orient" },
  { value: "americaine", label: "Américain" },
  { value: "europeenne", label: "Européenne" },
  { value: "autre", label: "Autre" },
];
export const cuisineLabel = (v) => (CUISINES.find((c) => c.value === v) || CUISINES[CUISINES.length - 1]).label;
